import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import SettingsMenuList from './SettingsMenuList'
import { ACCOUNT, APPEARANCE, CALLS, CHATS, CONTACTS, HELP, INTERFACE_LANGUAGES, VOICE_CLONING } from '../../Constants/constantValues'
import AccountSettings from './AccountSettings'
import ChatsSettings from './ChatSettins'
import ContactsSettings from './ContactsSettings'
import CallsSettings from './CallSettings'
import AppearanceSettings from './AppearanceSettings'
import InterfaceLanguageSettings from './InterfaceLanguageSettings'
import HelpSettings from './HelpSettings'
import VoiceCloningSettings from '../VoiceCloning/VoiceCloningSettings'
import { useAuthService } from '../../Context/AuthContext'

const SettingsMenu = () => {

    const [displayCategory, setDisplayCategory] = useState(ACCOUNT)

    const { translationsLanguages, getTranslationsLanguages, getCallTranslationsLanguages } = useAuthService();


    useEffect(() => {
        if (translationsLanguages.length != 0) {
            return;
        }
        getTranslationsLanguages(
            function (response) { },
            function (error) { }
        );
        getCallTranslationsLanguages(
            function (response) { },
            function (error) { }
        );
    }, []);

    return (
        <SettingsContainer>
            <SettingsMenuList
                displayCategory={displayCategory}
                setDisplayCategory={setDisplayCategory}
            />
            {displayCategory === INTERFACE_LANGUAGES && <InterfaceLanguageSettings />}
            {displayCategory === ACCOUNT && <AccountSettings />}
            {displayCategory === CONTACTS && <ContactsSettings />}
            {displayCategory === CHATS && <ChatsSettings />}
            {displayCategory === CALLS && <CallsSettings />}
            {displayCategory === APPEARANCE && <AppearanceSettings />}
            {displayCategory === HELP && <HelpSettings />}
            {displayCategory === VOICE_CLONING && <VoiceCloningSettings />}

        </SettingsContainer>
    )
}

export default SettingsMenu
const SettingsContainer = styled.div`
display:flex;
width:100%;
height:100%;
background:${({ theme }) => theme.menu.background};
`
